import { Outlet } from "react-router";
import { FilterProvider } from "../../../context/FilterProvider";

const ISOSummaryFilter = () => {
    return (
        <FilterProvider>
            <Outlet />
        </FilterProvider>
    );
}

export default ISOSummaryFilter;